export default {
    path: '/abnormal',
    name: 'Abnormal',
    component: () => import(/* webpackChunkName: "abnormal" */ '../../views/abnormal/abnormal.vue')
}